import { render, staticRenderFns } from "./dateSettings.vue?vue&type=template&id=2cc7a8bd"
import script from "./dateSettings.vue?vue&type=script&lang=js"
export * from "./dateSettings.vue?vue&type=script&lang=js"
import style0 from "./dateSettings.vue?vue&type=style&index=0&id=2cc7a8bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports